module.exports = new __parcel__URL__("NoResults.9d75157a.svg").toString();